<template>
  <div class="incomplete-alert flex text-center w-full flex-col">
    <div class="incomplete-alert__title">
      {{ $t('chat.confirm_body_scan_completion') }}
    </div>
    <div class="flex flex-col items-center">
      <CButton class="incomplete-alert__button mt-5" @click="$emit('confirm')">{{
        $t('chat.completed')
      }}</CButton>
      <CButton
        class="incomplete-alert__button incomplete-alert__button--secondary mt-5"
        secondary
        @click="$emit('cancel')"
        >{{ $t('chat.cancel_body_scan') }}</CButton
      >
    </div>
  </div>
</template>

<script>
import CButton from '@/components/common/CButton.vue';

export default {
  name: 'IncompleteAlert',
  components: {
    CButton,
  },
};
</script>

<style lang="scss" scoped>
.incomplete-alert {
  padding-left: 42px;
  padding-right: 42px;

  &__title {
    font-size: 20px;
    line-height: 1.6;
    font-weight: 600;
  }

  &__button {
    &--secondary {
      border-color: var(--primary-color) !important;
      color: var(--primary-color) !important;
    }
  }
}
</style>
